module.exports = __webpack_public_path__ + "images/vip-2c4f54d4fc8554ec42a31f09a659365a.png";